<template>
  <div>
    <div style="line-height:20px;">
      {{ gradeData.title }}
    </div>
    <a-select
      :placeholder="gradeData.placeholder"
      :value="value1"
      @change="handleChange"
    >
      <a-select-option
        v-for="item in gradeData.data"
        :key="item.id"
        :value="item.id"
      >
        {{ item.value }}
      </a-select-option>
    </a-select>
  </div>
</template>
<script>
export default {
  props: ['gradeData', 'value'],
  data() {
    return {
      value1: this.value,
    };
  },
  watch: {
    value(val){
      this.value1=val;
    },
  },
  mounted(){
    console.log(this);
  },
  methods: {
    handleChange(val){
      this.$emit('change', val);

    },
  },
};
</script>
